<template>
  <div>
    <search-bar :hasTitle="false" :backgroundColorGray="false"></search-bar>
    <!-- <section class="global-search">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div class="search-bar clearfix">
              <input
                type="text"
                class="form-control"
                placeholder="Busque pelo produto, filtro ou equivalência"
              >
              <button type="button" class="btn btn-primary btn-search">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <div class="banner-about">
      <img src="../../static/images/banner-5.jpg" alt>
    </div>
    <section class="section-gray section-about">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="text-center text-lg-left">Nossa história</h1>
            <p>A Japanparts é líder na distribuição de autopeças para o mercado de reposição independente na Itália, com mais de 20 anos de história e tradição.</p>
            <p>A marca é referência no continente Europeu, sinônimo de qualidade e segurança. Sua gama de produtos conta atualmente com mais de 23.000 itens, e ampla cobertura de aplicações para veículos Asiáticos e Europeus.</p>
            <p>Novos produtos são continuamente desenvolvidos e incluídos no portfólio para suprir as necessidades do mercado de manutenção e reparo.</p>
            <p>No Brasil, os produtos Japanparts são distribuídos com exclusividade pela Fast Lube, que possuí expertise no segmento de filtros automotivos desde 1993.</p>
            <p>Adequar as ferramentas de pesquisa, na forma impressa ou eletrônica ao mercado Brasileiro, facilitando a busca de produtos por aplicação, código Japanparts ou do concorrente foi decisivo para o crescimento das vendas.</p>
            <p>Produtos de qualidade, política comercial competitiva e uma entrega eficiente, completam o círculo virtuoso para o sucesso da Japanparts, também no Brasil.</p>
            <div class="mt-5 row">
              <div class="col-6 offset-3 col-md-4 offset-md-4">
                <router-link to="/contato">
                  <a href="#" class="btn btn-primary btn-block">Contato</a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix">
        <div class="d-lg-none mt-5 w-75 float-right">
          <img src="../../static/images/logo2.png" alt>
        </div>
      </div>
    </section>

    <div class="diagonal-line diagonal-line2"></div>


  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "About",
  components: { SearchBar }
};
</script>

<style lang="sass" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/About.vue